// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

// initialize an empty api service that we'll inject endpoints into later as needed
export const SkillsManagementClient = createApi({
    reducerPath: 'skillsManagementApi',
    tagTypes: ['Skills', 'Disciplines', 'Units'],
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_URL}`,  // Empty string to use the proxy configured in package.json
        credentials: 'include',
        prepareHeaders: (headers) => {
            headers.set('x-dgt-prdbpss', 'digitprod25')
            return headers
        },
    }),
    endpoints: () => ({})
})